import { Avatar, Box, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import { i18n } from "../../translate/i18n";
import LinkIcon from "@mui/icons-material/Link";

type Props = {
  equipment: {
    _id: string,
    photo?: {
      url: string
    },
    equipmentModel: {
      name: string,
    },
    serialNumber: string,
    place: { path: string },
    companies: { name: string }[],
  }
  serviceName: string,
  backPage: string,
};

const EquipmentInfo: React.FC<Props> = ({ equipment, serviceName, backPage }) => {


  const InfoWithLabels: React.FC<{ label: string, info: string}> = ({ label, info }) => {
    return <Box>
      <Typography sx={styles.label}>{label}</Typography>
      <Typography sx={styles.info}>{info}</Typography>
    </Box>
  };

  const companiesLabel = equipment.companies.length > 0 ? equipment.companies.map(({ name }) => name).join(', ') : '-';

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '12px'}}>
        {equipment.photo?.url ?
          <Avatar src={equipment.photo?.url} sx={styles.avatar} />
          :
          <Avatar sx={styles.avatarSmallText}>
            PHOTO
          </Avatar>
        }
        <Box width={'70%'} sx={{ marginLeft: '5px'}}>
          <Typography variant='subtitle1' fontWeight={600} noWrap width='100%' sx={{fontSize: 16}}>{equipment.equipmentModel.name}</Typography>
          <Typography
            variant='subtitle1'
            noWrap
            width='100%'
            sx={{
              color: 'rgba(0, 0, 0, 0.38)',
              fontSize: 12,
              fontWeight: '400',
              letterSpacing: 0.40
            }}
          >
            {equipment.serialNumber}
          </Typography>
        </Box>
        <IconButton
          sx={{ marginLeft: '5px', cursor: 'pointer', padding: '0px 3px 0px 3px', borderRadius: 3 }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          size="large"
          href={`/form-equip/${equipment._id}/${backPage}`}
          target="_blank"
        >
          <Tooltip title={i18n.t('editService.goToEquipment') as string}>
            <LinkIcon color='primary' />
          </Tooltip>
        </IconButton>
      </Box>
      <Box>
        <InfoWithLabels label={i18n.t('equipmentInfo.service')} info={serviceName} />
        <InfoWithLabels label={i18n.t('equipmentInfo.companies')} info={companiesLabel} />
        <InfoWithLabels label={i18n.t('equipmentInfo.place')} info={equipment.place.path} />
      </Box>
    </Box>
  )
};

export default EquipmentInfo;

const styles = {
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '3rem',
    height: '3rem',
  },
  avatar: {
    width: '3rem',
    height: '3rem',
  },
  label: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontSize: 12,
    fontWeight: '400',
    letterSpacing: 0.15,
    wordWrap: 'break-word'
  },
  info: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: 0.15,
    wordWrap: 'break-word'
  }
}
